export type ITypeLogin = 'phone' | 'password' | 'wechat' | 'google';

export const trackData = (type: ITypeLogin, values: any, other?: any) => {
  const route = useRoute();

  switch (type) {
    case 'phone':
      trackEvent(TRACK_EVENT.CLICK_LOGIN_BTN, {
        account_name: values.mobile,
        LoginWay: LOGIN_WAY.PHONE,
        source: route.query.code ? ACTIVITY_SOURCE.INVITE : ACTIVITY_SOURCE.OTHER,
        ...other,
      });
      break;
    case 'password':
      trackEvent(TRACK_EVENT.CLICK_LOGIN_BTN, {
        account_name: values.login_name,
        LoginWay: LOGIN_WAY.PASSWORD,
        ...other,
      });
      break;
    case 'wechat':
      trackEvent(TRACK_EVENT.CLICK_LOGIN_BTN, {
        LoginWay: LOGIN_WAY.WECHAT,
        ...other,
      });
      break;
    case 'google':
      trackEvent(TRACK_EVENT.CLICK_LOGIN_BTN, {
        account_name: values.email,
        LoginWay: LOGIN_WAY.GOOGLE,
        ...other,
      });
      break;
  }
};
